let _valueVersion = 0;
export const incrementValueVersion = () => ++_valueVersion;
